import { axiosInstance } from '@/plugins/axios';

export default {
	namespaced: true,
	state: {
    ebooksCategories: {},
		ebooks: {},
    ebook: {}
	},
	getters: {
    ebooksCategories(state) {
			return state.ebooksCategories;
		},
		ebooks(state) {
			return state.ebooks;
		},
    ebook(state) {
			return state.ebook;
		},
	},
	mutations: {
    SET_EBOOKS_CATEGORIES(state, value) {
			state.ebooksCategories = value;
		},
		SET_EBOOKS(state, value) {
			state.ebooks = value;
		},
    SET_EBOOK(state, value) {
			state.ebook = value;
		},
	},
	actions: {
    async registerCategoryEbooks(context, value) {
      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('name', value.name);

      const url = value.id ? `ebooks/categories/${value.id}` : 'ebooks/categories';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultCategoriesEbooks');
        })
    },
    async consultCategoriesEbooks(context){
      await axiosInstance({
        method: 'GET',
        url: 'ebooks/categories',
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_EBOOKS_CATEGORIES', data]);
        })
    },
    async removeCategoryEbooks(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `ebooks/categories/${id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultCategoriesEbooks');
        })
    },
    async registerEbook(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_ebook_category', value.id_ebook_category);
      formData.append('name', value.name);
      formData.append('contentHtml', value.contentHtml);
      formData.append('author', value.author);
      formData.append('gender', value.gender);
      formData.append('publishing_company', value.publishing_company);
      formData.append('year', value.year);
      formData.append('edition', value.edition);
      formData.append('language', value.language);
      formData.append('picture', value.picture);
      formData.append('file', value.file);
      formData.append('file_name', value.file_name);

      const url = value?.id ? `ebooks/${value.id}` : 'ebooks';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultEbooks');
        })
    },
    async consultEbooks(context, value){
      const url = value?.id ? `ebooks/${value.id}` : 'ebooks';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.id) {
            context.dispatch('setDataDefault', ['SET_EBOOK', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_EBOOKS', data]);
        })
    },
    async removeEbook(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `ebooks/${id}`,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_EBOOKS', data]);
        })
    },
    setDataDefault(context, [mutationName, value]){
      context.commit(`${mutationName}`, value);
    },
	}
}
